module.exports = __webpack_public_path__ + "img/图层 1 7@2x.8910ca9e.png";